// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/** Ripples */\n/** Elements */\n/* Palette generated by Material Palette - materialpalette.com/blue/amber */\n/** Ripples */\n/** Elements */\n.v-card[data-v-29c22c6e] {\n  max-width: 100%;\n  margin: auto;\n}\n@media only screen and (min-width: 700px) {\n.v-card[data-v-29c22c6e] {\n    width: 636px;\n}\n}", ""]);
// Exports
module.exports = exports;
